export const CommonCard = {
  background: 'overlayStrong',
  round: 'A',
  padding: 'A'
}
